import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useCauseNoteService from '../../../app/services/hooks/useCauseNoteService';

interface Props {
    causeNoteId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const CauseNoteSwitchChange = ({ causeNoteId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeCauseNote, fetchingActiveCauseNote } = useCauseNoteService();

    const active = (value: boolean) => {
        setChecked(value);

        activeCauseNote(causeNoteId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={causeNoteId} callback={active} />;
};

export default CauseNoteSwitchChange;
